import { createApi } from "@reduxjs/toolkit/query/react";
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import { setHasLoadedModes } from "@/redux/slices/evento-mode.slice";

export interface ModeConfig {
  eventos: { enabled: boolean; name: string };
  pequenosGrupos: { enabled: boolean; name: string };
  liderancas: { enabled: boolean; name: string };
  oracao: { enabled: boolean; name: string };
  ensino: { enabled: boolean; name: string };
  infantil: { enabled: boolean; name: string };
  devocionais: { enabled: boolean; name: string };
  igrejas: { enabled: boolean; name: string };
  /** Presente quando loginId é a org SysIgreja (12). */
  plus?: { enabled: boolean; name: string };
}

export interface ModesResponse {
  modes: ModeConfig;
}

const modesBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions,
) => {
  const { baseQueryWithReauth } = await import("@/lib/api");
  return baseQueryWithReauth(args, api, extraOptions);
};

export const modesAPI = createApi({
  reducerPath: "modesAPI",
  baseQuery: modesBaseQuery,
  tagTypes: ["Modes"],
  endpoints: (builder) => ({
    getAvailableModes: builder.query<ModesResponse, number>({
      query: (loginId) => ({
        url: `config-login/modes/${loginId}`,
        method: "GET",
      }),
      providesTags: ["Modes"],
      async onQueryStarted(_query, { dispatch, queryFulfilled }) {
        const { data } = await queryFulfilled;
        dispatch(setHasLoadedModes());
      },
    }),
    invalidateModes: builder.mutation<void, void>({
      query: () => ({
        url: "config-login/modes/invalidate",
        method: "POST",
      }),
      invalidatesTags: ["Modes"],
    }),
  }),
});

export const { useGetAvailableModesQuery, useInvalidateModesMutation } =
  modesAPI;
